<template>
  <div class="content">
    {{ Language.say(notification.message, notification.replacements) }}
    <a v-if="notification.link_type == 'external'"
      :href="Language.say(notification.link)"
      target="_blank"
      rel="noopener"
      :class="notification.link_class">
        <span v-if="notification.link_text">{{ Language.say(notification.link_text) }}</span>
        <i v-if="notification.link_icon" :class='notification.link_icon' aria-hidden="true"></i>
    </a>
    <router-link v-else
      :to="Language.say(notification.link)"
      :class="notification.link_class">
        <span v-if="notification.link_text">{{ Language.say(notification.link_text) }}</span>
        <i v-if="notification.link_icon" :class='notification.link_icon' aria-hidden="true"></i>
    </router-link>
  </div>
</template>
<script setup>
  import {defineProps}   from 'vue';
  import Language        from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    notification: Object
  });
</script>
